var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9673 6.88763H31.5898M31.5898 6.88763V13.5101M31.5898 6.88763L24.5534 15.5796M8.41113 31.7219L15.0336 25.0994M24.9673 31.7219H31.5898M31.5898 31.7219V25.0994M31.5898 31.7219L8.41113 8.54325",
    stroke: "white",
    strokeWidth: 3.31124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSwitch);
export default __webpack_public_path__ + "static/media/ic_switch.d62e88f7e6a598ad7e0165a821be2fa1.svg";
export { ForwardRef as ReactComponent };